<template>
<div class="greybg" :style="{minHeight: contentHeight}">
    <div class='currentscore'>
        <img src='@/assets/images/scoreicon.png' />
        <span>{{balance}}</span>积分
    </div>
    <div class='msgtips' v-if='expirationList.potentialPoint && expirationList.potentialPoint>0'>
        <img src='@/assets/images/msg.png' />
        <span>您有{{expirationList.potentialPoint}}积分将在{{expirationList.expirationDate}}过期</span>
    </div>
    <div>
    <van-list
      v-model="loading"
      :finished="finished"
      :immediate-check="false"
      @load="getPointList"
    >
      <div v-for="(item,index) in pointList" :key="item.referenceId+index">
        <div class='pointItem' @click='goTransDetails(item.exchangeType,item.referenceId)'>
          <div class='item-container-fg'>
            <div v-if='item.exchangeType=="TRANSACTION" && item.transPoint.indexOf("+")>-1' class='trade-title-black'>交易奖励积分</div>
            <div v-else class='trade-title-black'>{{exchangeTypeObj[item.exchangeType]}}</div>
            <div class='trade-detail-gray' v-if='item.exchangeType=="REGISTRATION"'>
              <p>验证门店：{{item.merchantName=="Pure Value"?"积惠多小程序":item.merchantName}}</p>
            </div>
            <div class='trade-detail-gray' v-else-if='item.exchangeType=="MANUALLY_DEDUCT" || item.exchangeType=="MANUALLY_ADD"'>
              
            </div>
            <div class='trade-detail-gray' v-else-if='item.exchangeType=="POINT_EXPIRED"'>
              <p>扣减详情：{{item.exchangeTimestamp2}}</p>
            </div>
            <div class='trade-detail-gray' v-else-if='item.exchangeType=="COMPLETE_PERSONAL_INFO"'>
              <p>活动名称：完善信息得积分</p>
            </div>
            <div class='trade-detail-gray' v-else-if='item.exchangeType=="COMMEND_COMPLETE_PERSONAL_INFO" || item.exchangeType=="COMMEND_COMPLETE_PERSONAL_INFO_SK"'>
              <p>活动名称：完善信息推荐奖励</p>
            </div>
            <div class='trade-detail-gray' v-else-if='item.exchangeType=="CUSTOMER_REFERENCE"'>
              <p>活动名称：推荐会员得积分</p>
            </div>
            <div class='trade-detail-gray' v-else-if='item.exchangeType=="DUIBA_BUQIAN_CONSUME_POINT"'>
              <p>活动名称：每日签到补签</p>
            </div>
            <div class='trade-detail-gray' v-else-if='item.exchangeType=="MEMBER_SIGN_IN"'>
              <p>活动名称：签到奖励</p>
            </div>
            <div class='trade-detail-gray' v-else-if='item.exchangeType=="DUIBA_GAME_ADD_POINT"'>
              <p>活动名称：游戏获得积分奖励</p>
            </div>
            <div class='trade-detail-gray' v-else-if='item.exchangeType=="DUIBA_GAME_CONSUME_POINT"'>
              <p>活动名称：参加游戏减少积分</p>
            </div>
            <div class='trade-detail-gray' v-else-if='item.exchangeType=="ORDER_CONSUME_AC" || item.exchangeType=="O2O_ORDER_DEDUCT" || item.exchangeType=="O2O_ORDER_REFUND"'>
              <p>订单编号：{{item.referenceId}}</p>
            </div>
            <div class='trade-detail-gray' v-else>
              <p>交易编号：{{item.referenceId}}</p>
              <p>交易门店：{{item.merchantName}}</p>
            </div>
            <div class='trade-detail-gray'>{{item.exchangeTimestampOrj}}</div>
          </div>
          <div class='trans-point' :style='{color:item.transPointColor}'>{{item.transPoint}}</div>
        </div>
      </div>
    </van-list>
  </div>
  <div class='nodata' v-if="pointList.length==0">
    <img src='@/assets/images/pic-no-record.png' />
    <div class='no-item-msg'>
        <div>您还没有积分明细记录哦</div>
        <div>只支持2018年7月6日之后的数据查询</div>
    </div>
  </div>
  <bottom v-if="pointList.length!=0"></bottom>
  <floatBar v-if="showBar"></floatBar>
</div>
</template>
<script>
const USED_POINT_COLOR = "#949494"
const EARNED_POINT_COLOR = "#EB6112"
import bottom from '@/components/nomore'
import floatBar from "../../components/floatBar"
export default {
    name: '',
    data () {
        return {
            balance: "0",
            pointList: [],
            expirationList:{},
            pageSize: 15,
            loading: false,
            finished: false,
            contentHeight: 0,
            showBar: false,
            exchangeTypeObj: {
              "TRANSACTION": "交易支付",//交易支付
              "EARNED_POINT": "交易奖励积分",
              "COMPLETE_PERSONAL_INFO": "完善信息奖励积分",
              "CUSTOMER_REFERENCE": "推荐会员奖励积分",
              "MANUALLY_DEDUCT": "系统积分变动",
              "MANUALLY_ADD": "系统积分变动",
              "REGISTRATION": "新会员注册积分奖励",
              "COMMEND_COMPLETE_PERSONAL_INFO": "完善信息推荐奖励",
              "COMMEND_COMPLETE_PERSONAL_INFO_SK": "完善信息推荐奖励",
              "O2O_ORDER_DEDUCT": "商城订单抵扣积分",
              "O2O_ORDER_REFUND": "商城订单退还积分",
              "ORDER_CONSUME_AC": "商城订单完成奖励积分",
              "POINT_EXPIRED": "积分过期扣减",
              "DUIBA_BUQIAN_CONSUME_POINT": "每日签到补签",
              "MEMBER_SIGN_IN": "签到奖励",
              "DUIBA_GAME_ADD_POINT": "游戏获得积分奖励",
              "DUIBA_GAME_CONSUME_POINT": "参加游戏减少积分",
            }
        }
    },
    components:{
      bottom,
      floatBar
    },
    mounted(){
      // 初始化
      this.getPointBalance();
      this.getPointExpiration();
      this.getPointList();
      this.showBar = this.$route.query.showBar || false
      let initTime = this.initTime
        this.$service.getStatisCommon("evn_dom_finish",{initTime:initTime})
    },
    created(){
        window.addEventListener('resize', this.getHeight);
        this.getHeight()
    },
    methods: {
      getHeight(){
        this.contentHeight = document.documentElement.clientHeight + "px";
      },
      async getPointBalance(){
        let memberId=localStorage.getItem(this.$env+"memberId")
        let data = await this.$service.getPointBalance(memberId);
        if(data.result){
            if (data.result =='degrade'){
                this.balance= 0
            }else{
                this.balance=data.result
            }
        }
      },
      async getPointExpiration(){
        let memberId=localStorage.getItem(this.$env+"memberId")
        let res = await this.$service.getPointExpiration(memberId);
        if (res.result.length>0) {
            let data=res.result;
            // XXX:Fix bug 接口expirationDate返回null会导致split方法报错阻断运行
            // let arrTime = data[0].expirationDate.split(" ")[0].split("/");
            data[0].expirationDate="2021年5月31日";
            // data[0].expirationDate=arrTime[2] + "年" + arrTime[1] + "月" + arrTime[0] + "日";
            this.expirationList= ''//data[0]
        }
      },
      async getPointList() {
        let toast = this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        let lastSearchTime = ""
        if (this.pointList.length > 0) {
            lastSearchTime = this.pointList[this.pointList.length - 1].exchangeTimestamp
        }
        let params = {
            "maxSearchCount": this.pageSize,
            "startSearchTime": lastSearchTime
        }
        let memberId=localStorage.getItem(this.$env+"memberId")
        let res = await this.$service.getPointList(memberId,params);
        this.loading = false;
        toast.close();
        if (res.result.length>0) {
          res.result.forEach((item)=>{
            let arrTime=item.exchangeTimestamp.split(" ");
            let arrTimeStr=arrTime[0].split("/").reverse();
            item.exchangeTimestampOrj=arrTimeStr.join("-")+" "+arrTime[1];
            if(item.exchangeType=="POINT_EXPIRED"){
              item.exchangeTimestamp2=arrTimeStr[0]+ "年" + arrTimeStr[1] + "月" + arrTimeStr[2] + "日前全部积分";
            }
            if(item.usedPoint !== "0" && item.usedPoint !== "--" && item.earnedPoint !== "0"){
              item.transPoint = item.usedPoint;
              item.transPointColor = USED_POINT_COLOR;
            }else if(item.earnedPoint !== "0"){
              item.transPoint = "+" + item.earnedPoint;
              item.transPointColor = EARNED_POINT_COLOR;
            }else{
              item.transPoint = item.usedPoint;
              item.transPointColor = USED_POINT_COLOR;
            }
          })
          let list = res.result || [];
          this.pointList = [...this.pointList, ...list];

          if(res.result.length < this.pageSize){
            this.finished = true
          }
         
          // 如果总页数大于当前页码，页码+1
        }else{
          this.finished = true;
        }

        let initTime = this.initTime
          this.$service.getStatisCommon("evn_open_page",{initTime: initTime});
      },
      goTransDetails(exchangeType,transId){
        if(!transId || transId === '--'){
          return
        }
        
        if (exchangeType === "REGISTRATION" || exchangeType === "COMPLETE_PERSONAL_INFO" || exchangeType === "CUSTOMER_REFERENCE" || exchangeType === "POINT_EXPIRED") {
          return
        } else if (exchangeType === "O2O_ORDER_DEDUCT" || exchangeType === "O2O_ORDER_REFUND" || exchangeType === "ORDER_CONSUME_AC"){
          this.$router.push({path:'/orderDetail',query:{orderId:transId}})
          this.$service.getStatisCommon("evn_close_page",{});
        } else {
          return
          // this.$router.push({path:'/transactionDetail',query:{transId:transId}})
        }
      },
     
    }
}
</script>
<style scoped>
.currentscore{
  background-image: linear-gradient(90deg, #fe6141 0%, #FFC35C 100%);
  color: white;
  text-align: center;
  font-size: 0.4267rem;
  width: 100%;
  height: 2.9333rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC-Regular;
}
.currentscore img{
  width: 0.64rem;
  margin-right: 0.3467rem;
}
.currentscore span{
  font-size: 0.8533rem;
  font-family: PingFangSC-Medium;
  margin-right: 0.08rem;
}

.msgtips{
  width: 9.36rem;
  height: 1.28rem;
  display: flex;
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0 0 0.08rem 0 rgba(0,0,0,0.05);
  border-radius: 0.2133rem;
  margin: 0 auto;
  padding: 0 0.32rem;
  box-sizing: border-box;
  margin-top: -0.64rem;
}
.msgtips img{
  width: 0.5867rem;
  margin-right: 0.32rem;
}
.msgtips span{
  font-family: PingFangSC-Regular;
  font-size: 0.3733rem;
  color: #707070;
  letter-spacing: 0;
  padding-left: 0.32rem;
  border-left:1px solid #EBEBEB;
}
.pointItem{
  width:9.36rem;
  margin: 0.2133rem auto 0;
  display: flex; 
  justify-content: space-between;
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0 0 0.16rem 0 rgba(0,0,0,0.05);
  border-radius: 0.2133rem;
  padding:0.4267rem;
  box-sizing: border-box;
}

.item-container-fg {
   line-height: 1.4;
}
.trans-point {
  font-family: PingFangSC-Medium;
  font-size: 0.5333rem;
  letter-spacing: 0;
  text-align: right;
} 
.trade-title-black{
  font-family: PingFangSC-Medium;
  color: #333333;
  font-size: 0.4267rem;
  line-height: 1.4;
  margin-bottom: 0.12rem;
}
.trade-title-orange{
  font-family: PingFang-SC-Semibold, 'Source Han Sans CN Bold','Noto Sans CJK SC Bold';
  color: rgb(235,97,15); 
  font-size: 0.3867rem;
}
.trade-title-blue{
  font-family: PingFang-SC-Semibold, 'Source Han Sans CN Bold','Noto Sans CJK SC Bold';
  font-size: 0.5867rem;
}

.trade-detail-gray{
  font-family: PingFangSC-Regular;
  font-size: 0.32rem;
  color: #949494;
  letter-spacing: 0;
}
.trade-detail-orange{
  font-family: PingFangSC-Regular;
  font-size: 0.32rem;
  letter-spacing: 0;
  color: rgb(235,97,15); 
} 
.no-item-msg {
  margin-bottom:0.4rem;
  font-size: 0.4533rem;
  color:rgb(154,156,155);
}
.no-item-msg div{
  text-align: center;
  line-height: 1.4;
}
.nodata{
  text-align: center;
  padding: 20% 0;
}
.nodata img{
  width: 50%;
}

</style>
